import { render, staticRenderFns } from "./MSelect.vue?vue&type=template&id=96b2ced4&scoped=true&"
import script from "./MSelect.vue?vue&type=script&lang=js&"
export * from "./MSelect.vue?vue&type=script&lang=js&"
import style0 from "./MSelect.vue?vue&type=style&index=0&id=96b2ced4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b2ced4",
  null
  
)

export default component.exports